module.exports = __webpack_public_path__ + "img/santa.c2a6ef50.png";